/**
 * LOP Product Gallery Zoom
 * Maneja el zoom de imágenes de producto en desktop usando PhotoSwipe
 */

class LOPProductGalleryZoom {
  constructor() {
    this.init();
  }

  init() {
    // Solo ejecutar en desktop
    if (window.innerWidth < 1024) return;
    
    this.galleryContainer = document.querySelector('.LOP-product-gallery-grid');
    if (!this.galleryContainer) return;

    this.setupGalleryItems();
    this.setupEventListeners();
  }

  setupGalleryItems() {
    this.galleryItems = Array.from(this.galleryContainer.querySelectorAll('.LOP-product-gallery-item'));
    
    // Agregar overlay de zoom a cada imagen
    this.galleryItems.forEach((item, index) => {
      const overlay = document.createElement('div');
      overlay.className = 'LOP-zoom-overlay';
      overlay.dataset.index = index;
      
      const img = item.querySelector('img');
      if (img) {
        // Obtener URL de imagen en alta resolución
        const highResUrl = this.getHighResImageUrl(img.src);
        overlay.dataset.src = highResUrl;
        overlay.dataset.w = img.naturalWidth || 1200;
        overlay.dataset.h = img.naturalHeight || 1200;
        overlay.dataset.alt = img.alt || '';
      }
      
      item.appendChild(overlay);
    });
  }

  getHighResImageUrl(src) {
    // Convertir URL de imagen a alta resolución (remover limitaciones de tamaño de Shopify)
    return src.replace(/(_\d+x\d*|_\d*x\d+|_compact|_medium|_large|_grande|_master)/g, '')
              .replace(/\?.*$/, '') + '?v=' + Date.now();
  }

  setupEventListeners() {
    // Agregar evento click a cada item de galería
    this.galleryItems.forEach((item) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        const overlay = item.querySelector('.LOP-zoom-overlay');
        if (overlay) {
          this.openLightbox(parseInt(overlay.dataset.index));
        }
      });
    });

    // Reconfigurar cuando cambie el tamaño de ventana
    window.addEventListener('resize', () => {
      if (window.innerWidth < 1024) {
        this.destroy();
      } else if (!this.galleryContainer.querySelector('.LOP-zoom-overlay')) {
        this.init();
      }
    });
  }

  buildPhotoSwipeItems() {
    return this.galleryItems.map((item) => {
      const overlay = item.querySelector('.LOP-zoom-overlay');
      const img = item.querySelector('img');
      
      return {
        src: overlay.dataset.src,
        w: parseInt(overlay.dataset.w) || 1200,
        h: parseInt(overlay.dataset.h) || 1200,
        title: overlay.dataset.alt || ''
      };
    });
  }

  openLightbox(index) {
    // Verificar que PhotoSwipe esté disponible
    if (typeof PhotoSwipe === 'undefined' || typeof PhotoSwipeUI_Default === 'undefined') {
      console.warn('PhotoSwipe no está disponible');
      return;
    }

    const pswpElement = document.querySelector('.pswp');
    if (!pswpElement) {
      console.warn('Elemento .pswp no encontrado');
      return;
    }

    const items = this.buildPhotoSwipeItems();
    
    const options = {
      index: index,
      maxSpreadZoom: 3,
      loop: true,
      allowPanToNext: false,
      closeOnScroll: false,
      showHideOpacity: true,
      arrowKeys: true,
      history: false,
      captionEl: true,
      fullscreenEl: true,
      zoomEl: true,
      shareEl: false,
      counterEl: true,
      arrowEl: true,
      preloaderEl: true,
      getThumbBoundsFn: (index) => {
        const item = this.galleryItems[index];
        if (!item) return null;
        
        const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
        const rect = item.getBoundingClientRect();
        
        return {
          x: rect.left,
          y: rect.top + pageYScroll,
          w: rect.width
        };
      }
    };

    const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
    
    // Personalizar los controles
    gallery.listen('firstUpdate', () => {
      gallery.listen('parseVerticalMargin', (item) => {
        item.vGap = {
          top: 50,
          bottom: 50
        };
      });
    });

    gallery.init();
  }

  destroy() {
    // Remover overlays de zoom
    const overlays = this.galleryContainer.querySelectorAll('.LOP-zoom-overlay');
    overlays.forEach(overlay => overlay.remove());
    
    // Remover event listeners de los items
    this.galleryItems.forEach(item => {
      item.replaceWith(item.cloneNode(true));
    });
  }
}

// Inicializar cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', () => {
  new LOPProductGalleryZoom();
});

// Reinicializar en navegación AJAX (si aplica)
document.addEventListener('product:variant-change', () => {
  // Pequeño delay para que se actualicen las imágenes
  setTimeout(() => {
    new LOPProductGalleryZoom();
  }, 100);
});
